import { types } from "../action_types";

const INITIAL_STATE = {
  getLoading: false,
  createLoading: false,
  editLoading: false,
  deleteLoading: false,
  settings: null,
  pagination: null,
};

const SettingsReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.GetSettingsRequest:
      return { ...state, getLoading: true };
    case types.GetSettingsRequestSuccess:
      return {
        ...state,
        settings: payload.settings,
        pagination: payload.pagination,
        getLoading: false,
      };
    case types.GetSettingsRequestFailure:
      return { ...state, getLoading: false };

    case types.CreateSettingsRequest:
      return { ...state, createLoading: true };
    case types.CreateSettingsRequestSuccess:
      return { ...state, createLoading: false };
    case types.CreateSettingsRequestFailure:
      return { ...state, createLoading: false };

    case types.EditSettingsRequest:
      return { ...state, editLoading: true };
    case types.EditSettingsRequestSuccess:
      return { ...state, editLoading: false };
    case types.EditSettingsRequestFailure:
      return { ...state, editLoading: false };

    default:
      return state;
  }
};
export default SettingsReducer;
